import React from 'react';
import PropTypes from 'prop-types';
import {
  DtpCheckbox,
} from 'dtp-react-components';

const Checkbox = props => (
  <DtpCheckbox
    label={props.label}
    selectedValue={props.value}
    disabled={props.disabled}
    {...props}
  />
);

Checkbox.defaultProps = {
  value: null,
  name: null,
  disabled: false,
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  optionsList: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })).isRequired,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Checkbox.jsx